import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

//css
import { Row, Col, Card, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

//pages
import { Loading, AppPagination } from "../../components/Index.js";
import AppNav from "../../../header/AppNav";

function PatientsHistoryDetails() {
  //   const [addModalShow, setAddModalShow] = useState(false);
  //   const [loading, setLoading] = useState(false);
  //   const [pagination, setPagination] = useState({
  //     cur: 1,
  //     max: 1,
  //   });

  //   const [taluk, setTaluk] = useState([]);

  //   const getTaluk = async (page = 1) => {
  //     setLoading(true);
  //     try {
  //       const res = await TalukServices.getTaluk(page);
  //       if (res.data?.length > 0) {
  //         setTaluk(res.data);
  //         setPagination({
  //           cur: res.pagination_data.page,
  //           max: res.pagination_data.pages,
  //         });
  //       } else {
  //         setTaluk([]);
  //         setPagination({
  //           cur: 1,
  //           max: 1,
  //         });
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       alert(error.message);
  //       setLoading(false);
  //     }
  //   };

  //   const deleteTaluk = async (id) => {
  //     setLoading(true);
  //     try {
  //       const val = window.confirm("Do you want to delete?");
  //       if (val) {
  //         const res = await TalukServices.deleteTaluk(id);
  //         if (res.status === 200) {
  //           alert(res.message);
  //           getTaluk(pagination.cur);
  //         } else {
  //           alert("Error while deleting");
  //         }
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       alert(error.message);
  //       setLoading(false);
  //     }
  //   };

  //   const changePage = (page) => {
  //     getTaluk(page);
  //   };
  //   useEffect(() => {
  //     getTaluk();
  //   }, []);

  return (
    <div>
      <AppNav />
      <h1 className="list-style">Patient's Details</h1>
      <Container>
        <Card className="patients-cards-spacing">
          <Card.Body>
            <Row>
              <Col>
                <p>
                  Patient Name:<h5>Ramesh</h5>
                </p>
              </Col>
              <Col>
                <p>
                  Patient ID:
                  <h5>123456</h5>
                </p>
              </Col>
              <Col>
                <p>
                  Gender:<h5>Male</h5>
                </p>
              </Col>
              <Col>
                <p>
                  Age:<h5>35</h5>
                </p>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <p>
                  Mobile no:<h5>9562314785</h5>
                </p>
              </Col>
              <Col>
                <p>
                  Aadhar no:
                  <h5>2345 6789 0987</h5>
                </p>
              </Col>
              <Col>
                <p>
                  Asha Name::<h5>Suma</h5>
                </p>
              </Col>
              <Col>
                <p>
                  Asha Block:<h5>Shimoga Block5</h5>
                </p>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <p>
                  Address:<h5>#105, 1st cross, HR colony, Sagara - 577321</h5>
                </p>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <p>
                  Insurance:<h5>ESI</h5>
                </p>
              </Col>
              <Col>
                <p>
                  Intrested in Eye Donation:<h5>Yes</h5>
                </p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default PatientsHistoryDetails;
